import { useParams } from 'react-router-dom'
import Breadcrumb from '@/components/ui/Breadcrumb'
// import StrategicPillars from '@/components/sections/StrategicPillars'
import RecentArticles from '@/components/sections/RecentArticles'
import Newsletter from '@/components/sections/Newsletter'
import LoadingSpinner from '@/components/ui/LoadingSpinner'
import { motion } from 'framer-motion'
import { fadeUp, staggerContainer } from '@/lib/motion'
import {useAllMemberCountries} from '@/lib/api/hooks/member-country'
import { sanitizeHtml } from '@/utils/helpers/html'
export default function CountryProfile() {
  const { countryId } = useParams<{ countryId: string }>()

  
  const { data: allCountriesData, isLoading, isError, refetch } = useAllMemberCountries()
  const allCountries = allCountriesData?.data || []
  const country = allCountries.find(country => country.countryId === countryId)
  
  // Show loading state
  if (isLoading) {
    return (
      <LoadingSpinner fullScreen size="lg" message="Loading country profile..." />
    )
  }

  // Show error state
  if (isError) {
    return (
      <div className="min-h-screen bg-white">
        <div className="px-4 md:px-20 py-16">
          <div className="text-center">
            <h1 className="text-2xl font-normal font-['PT_Serif'] text-gray-900 mb-4">
              Error Loading Country
            </h1>
            <p className="text-lg font-['Satoshi'] text-gray-600 mb-4">
              There was a problem loading the country profile.
            </p>
            <button
              onClick={() => refetch()}
              className="px-4 py-2 bg-forestGreen-100 text-white rounded hover:bg-forestGreen-200 transition-colors"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (!country) {
    return (
      <div className="min-h-screen bg-white">
        <div className="px-4 md:px-20 py-16">
          <div className="text-center">
            <h1 className="text-2xl font-normal font-['PT_Serif'] text-gray-900 mb-4">
              Country Not Found
            </h1>
            <p className="text-lg font-['Satoshi'] text-gray-600">
              The requested country profile could not be found.
            </p>
          </div>
        </div>
      </div>
    )
  }

  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Member Countries', href: '/about/member-countries' },
    { label: country.countryName, href: '', active: true }
  ]

  return (
    <motion.div
      className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8"
      variants={staggerContainer}
      initial="hidden"
      animate="visible"
    >
      {/* Breadcrumb */}
      <motion.div className="mb-5" variants={fadeUp}>
        <Breadcrumb items={breadcrumbItems} />
      </motion.div>

      <motion.div
        className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16"
        variants={fadeUp}
      >
        {/* Main Content */}
        <div className="lg:col-span-2">
          {/* Country Header Section */}
          <div className="mb-16 space-y-6">
            {/* Country Flag */}
            <div className="w-72 h-52 mb-6">
              <img
                src={country.flagUrl}
                alt={`${country.countryName} flag`}
                className="w-full h-full object-cover rounded"
              />
            </div>

            {/* Country Title */}
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-normal font-pt-serif text-gray-900 leading-tight lg:leading-12">
              {country.countryName}
            </h1>

            {/* Country Description Section */}
            <div className="space-y-6">
              <h2 className="text-2xl font-normal font-pt-serif leading-loose text-green-700">
                {country.title}
              </h2>
              <div className="space-y-8">
             {country.description ?  <p className="" dangerouslySetInnerHTML={{ __html: sanitizeHtml(country.description) }} /> : null}
                  
             
              </div>
            </div>
          </div>

          {/* Newsletter Section */}
          <div className="mb-16">
            <Newsletter />
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-10">
          <RecentArticles />
          {/* <StrategicPillars /> */}
        </div>
      </motion.div>
    </motion.div>
  )
}
